const { default: authConstant } = require("../constants/authConstant")

export const authenticateAction = (data) => {
    return {
        type: authConstant.USER_AUTHENTICATE,
        payload: {
            token: data.jwt,
            // refreshToken:data.refreshToken,
            // roleId: data.roleId,
            // permissions: data.permissions,
            // userId: data.userId,
            vendor: data.vendorDto
        },
    }
}

export const authenticateAdminAction = (data) => {
    return {
        type: authConstant.ADMIN_LOGIN,
        payload: data,
    }
}

export const registerAction = (data) => {
    // TODO : check RESPONSE and modify payload
    return {
        type: authConstant.USER_REGISTER,
        payload: data,
    }
}

export const logoutAction = () => {
    return {
        type: authConstant.USER_LOGOUT,
    }
}

export const updateVendorDetailsAction = (vendorDetails) => {
    return {
        type: authConstant.UPDATE_VENDOR_DETAILS,
        payload: vendorDetails
    }
}